// extracted by mini-css-extract-plugin
module.exports = {"base":"_1872v3","title":"_2xO1hX","addToCartRecommendations":"_1HGy9_","invisible":"xNq9oC","visible":"_2_Tjzw","cardWrapper":"_5WG_N5","card":"QuAKtg"};